export class TipoForm {
    public readonly CREAR: string = "CREAR";
    public readonly EDITAR: string = "EDITAR";

    constructor() { }
}
